<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {ref, watch,computed, onMounted, PropType} from "vue";
import {MultiSelectOption} from "/@src/models/form";
import { activePanel } from '/@src/state/activePanelState'

//props
const props = defineProps({
  options: {
    type: Array as PropType<MultiSelectOption[]>,
    default: () => []
  },
  type: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  }
})

//data
const {t} = useI18n()
const currentType = ref(props.type || '')

//emit
const emit = defineEmits<{
  (e: 'update:type', value: string): void,
  (e: 'change', value: any): void
}>()

//watch
watch(() => props.type, (val) => {
  currentType.value = val
})

//computed
const contentText = computed(() => {
  let text = ''
  switch (currentType.value) {
    case 'omenReport':
      text = t('form-field-omen-report')
      break;
    case 'article':
      text = t('btn-choose-article')
      break;
    case 'video':
      text = t('btn-choose-video')
      break;
    case 'roadshow':
      text = t('btn-choose-roadshow')
      break;
    case 'product':
      text = t('btn-choose-products')
      break;
    case 'coupon':
      text = t('btn-choose-coupon')
      break;
    case 'post':
      text = t('btn-choose-post')
      break;
    case 'transcript':
      text = t('btn-choose-transcript')
      break;
  }
  return text
})

//methods 
const openPanel = () => {
  switch (currentType.value) {
    case 'omenReport':
      activePanel.value = 'searchOmenReport'
      break;
    case 'article':
      activePanel.value = 'searchArticle'
      break;
    case 'video':
      activePanel.value = 'searchVideo'
      break;
    case 'roadshow':
      activePanel.value = 'searchRoadshow'
      break;
    case 'coupon':
      activePanel.value = 'searchCoupon'
      break;
    case 'product':
      activePanel.value = 'searchProduct'
      break;
    case 'post':
      activePanel.value = 'searchPost'
      break;
    case 'transcript':
      activePanel.value = 'searchTranscript'
      break;
  }
}

const handleChangeType = (type: String) => {
  emit('change',type)
}
</script>

<template>
  <V-Field class="flex items-center">
    <label class="mr-5">{{t('edit-form-notification-type')}}</label>
    <V-Control>
      <Multiselect
        v-model="currentType"
        :can-clear="false"
        :placeholder="t('placeholder-edit-form-paid-type')"
        :options="options"
        @change="handleChangeType"
      />
    </V-Control>
    <V-Button
      v-if="contentText"
      class="btn-action ml-2"
      color="primary"
      raised
      @click="openPanel">
    {{ contentText }}
    </V-Button>
  </V-Field>
</template>

<style lang="scss" scoped>
</style>
